import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";
import { langId } from "@escapio/shared/l10n/lang-id";

window.googletag = window.googletag || { cmd: [] };

if (langId !== "de") {
	window.addEventListener("load", () => {
		hasAllPurposesConsent.then(() => {
			const script = document.createElement("script");
			script.async = true;
			script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
			script.type = "text/javascript";
			document.head.appendChild(script);
		});
	});
}

export const googletag = window.googletag;

/*
 * Register callbacks for render update events for a given slot.
 * These get isEmpty information as argument (false when some ad is shown in slot).
 */
const renderCallbacks = new Map();
export function registerRenderCallback(slotId, callback) {
	if (!renderCallbacks.has(slotId)) {
		renderCallbacks.set(slotId, new Set());
	}
	const callbacks = renderCallbacks.get(slotId);
	callbacks.add(callback);
}
export function unregisterRenderCallbacks(slotId) {
	renderCallbacks.delete(slotId);
}

googletag.cmd.push(() =>
	googletag.pubads().addEventListener("slotRenderEnded", event => {
		const slot = event.slot;
		const callbacks = renderCallbacks.get(slot.getSlotElementId());
		if (callbacks) {
			callbacks.forEach(callback => callback(event.isEmpty));
		}
	}),
);
